const PAGE_SERVICE_PAGE_SIZE_TABLE_DEFAULT = 10;
const PAGE_SERVICE_PAGE_SIZE_TABLE_ACCOUNT = 6;
const PAGE_SERVICE_PAGE_NUM_TABLE_DEFAULT = 1;

const STATUS = [
  'Initiating Transaction',
  'Acquiring Fund from Customer',
  'Disbursing Fund to DANA Balance',
  'Disbursing Fund to Bank Account',
  'Manual Fund Disbursement to Bank Account',
  'Selling Gold at Partner',
  'Sell Order Execution Failed at Partner',
  'Buy Order Execution Failed at Partner',
  'Register User Execution Failed at Partner',
  'Failed to Acquire Fund',
  'Failed to Disburse to DANA Balance',
  'Failed to Disburse to Bank Account',
  'Transaction Expired',
  'Transaction Completed',
  'Refund Completed',
];

const PAYMENT_OPTION = [
  'BALANCE',
  'CASHOUT',
  'COUPON',
  'CREDIT_CARD',
  'DEBIT_CARD',
  'NET_BANKING',
  'DIRECT_DEBIT_CREDIT_CARD',
  'DIRECT_DEBIT_DEBIT_CARD',
  'OTC',
  'TOP_UP',
  'VIRTUAL_ACCOUNT',
];

const STATE = [
  'IN_PROGRESS',
  'MANUAL_DISBURSE_IN_PROGRESS',
  'IN_PROGRESS_TRX',
  'IN_PROGRESS_OTC',
  'FAILED',
  'FAILED_TRX',
  'FAILED_OTC',
  'SUCCESS',
  'COMPLETED',
  'INIT',
  'MANUAL_REFUND',
  'REFUNDED',
  'UNVERIFIED',
  'PENDING',
  'VERIFIED',
  'EXPIRED',
  'CLOSED',
  'UNKNOWN',
];

const STATE_OPTIONS = ['COMPLETED', 'FAILED'];

export {
  PAGE_SERVICE_PAGE_SIZE_TABLE_DEFAULT,
  PAGE_SERVICE_PAGE_SIZE_TABLE_ACCOUNT,
  PAGE_SERVICE_PAGE_NUM_TABLE_DEFAULT,
  PAYMENT_OPTION,
  STATE_OPTIONS,
  STATUS,
  STATE,
};
